module.exports = __webpack_public_path__ + "static/media/theme-logo.bea35e11.svg";